<template>
  <div class="qrcode">
    <div class="qrcode-bg"></div>
    <div @touchmove.prevent="onContentMove" class="qrcode-content">
      <img class="logo-img" src="../../assets/home/logo_new_white.png" />
      <div class="store-text">{{ detailData.remark }}</div>
      <img :src="detailData.qr_code" class="qrcode-img" />
      <div class="qrcode-desc">长按识别，添加运动大使</div>
      <div class="benfit-content">
        <img alt class="benfit-img" src="../../assets/home/benefit_img.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDetail } from './_service'
import share from '../../_mixins/share'

const DEFAULT_REMARK = '迪卡侬会员优选群'
const DEFAULT_QR_CODE =
  process.env.NODE_ENV == 'production'
    ? require('../../assets/image/qrcode_pr.jpg')
    : require('../../assets/image/qrcode_dev.jpg')

export default {
  name: 'qrcode_page',
  mixins: [share],
  data() {
    return {
      detailData: {},
    }
  },
  computed: {
    ...mapGetters('channel', ['channel', 'campaign']),
  },
  mounted() {
    // 处理微信分享
    this.wxShare()

    const { storeId, name } = this.$route.query
    if (!storeId) {
      this.detailData = {
        remark: DEFAULT_REMARK,
        qr_code: DEFAULT_QR_CODE,
      }
    } else {
      let params = {
        storeId,
        channel: this.channel,
        name,
      }
      getDetail(params).then((data) => {
        let { remark = DEFAULT_REMARK, qr_code = DEFAULT_QR_CODE } = data
        this.detailData = {
          remark,
          qr_code,
        }
      })
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
@import './qrcode.less';
</style>
